import * as React from "react";
import "../index.scss";

interface Props {
  toggle: boolean;
}

const CreateIcon = ({ toggle }) => (
  <svg
    className="navbar-icon" 
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path 
      fillRule="evenodd" clipRule="evenodd"
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
      fill={toggle ? "#FF1D58" : "#000000"}
    />
  </svg>
);

export default CreateIcon;
